import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import judge from './judge.js'
import { getTouristsVal } from '@/utils'

Vue.use(Router)

// 新的路由需要到App.vue中过滤掉
export const routesArr = [
  {
    path: '/',
    redirect: '/list'
  },
  {
    path: '/error',
    name: 'error',
    component: () => import('@/views/ErrorBoundary' /* webpackChunkName: "error" */)
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      brand: true
    },
    component: () => import('@/views/Login' /* webpackChunkName: "login" */)
  },
  {
    path: '/test',
    name: 'test',
    meta: {
      needLogin: true
    },
    component: () => import('@/views/Test' /* webpackChunkName: "test" */)
  },
  {
    path: '/pretest',
    name: 'pretest',
    meta: {
      needLogin: true
    },
    component: () => import('@/views/Pretest' /* webpackChunkName: "pretest" */)
  },
  {
    path: '/list',
    name: 'list',
    meta: {
      needLogin: true
    },
    component: () => import('@/views/List' /* webpackChunkName: "list" */)
  },
  {
    path: '/touristsmsg',
    name: 'touristsmsg',
    component: () => import('@/views/touristsPage' /* webpackChunkName: "list" */)
  },
  {
    path: '/thirdLogin',
    name: 'thirdLogin',
    component: () =>
      import('@/views/Login/ThirdLogin' /* webpackChunkName: "thirdLogin" */),
    meta: {
      layout: 'Noop'
    }
  },
  {
    path: '/showPaper',
    name: 'showPaper',
    // meta: {
    //   needLogin: true
    // },
    component: () => import('@/views/ExamineePaperView' /* webpackChunkName: "showPaper" */)
  },
  {
    path: '/jumpPage',
    name: 'jumpPage',
    component: () => import('@/views/jumpPage' /* webpackChunkName: "jumpPage" */)
  },
  {
    path: '/judge',
    component: () => import('@/views/Judge/index.vue' /* webpackChunkName: "user" */),
    children: judge,
    meta: {
      specialRouter: true, // 不走站点逻辑
      needLogin: true
    }
  },
  {
    path: '/detect',
    name: 'detect',
    component: () => import('@/views/Detect' /* webpackChunkName: "detect" */),
    meta: {
      needLogin: true,
      layout: 'Noop'
    }
  },
  {
    path: '/identityCheck',
    name: 'identityCheck',
    component: () => import('@/views/IdentityCheck' /* webpackChunkName: "IdentityCheck" */),
    meta: {
      needLogin: true,
      layout: 'Noop'
    }
  }
]

const router = new Router({
  mode: 'history',
  linkExactActiveClass: 'active',
  linkActiveClass: 'link-active',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: []
})

// 登录态判断
router.beforeEach(async (to, from, next) => {
  const isTourists = getTouristsVal()
  if (!isTourists) {
    if (to.meta.needLogin && !store.state.hasToken) {
      try {
        await Vue.prototype.$auth('get_access_token')
        store.commit('HAS_TOKEN', true)
        next()
      } catch (error) {
        return next({ name: 'login' })
      }
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
